"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStores = void 0;
const react_1 = require("react");
const useStore_1 = require("./useStore");
const useStores = () => (0, react_1.useContext)(useStore_1.StoreContext);
exports.useStores = useStores;
